/**
 * @desc 获取当前登录供应商用户的信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierAccount/getCurrentUserInfo`, {
      method: "GET",

      ...options,
    }),
  );
}
